import {
  styled,
  css,
  Box,
  InputBase,
  List,
  Backdrop,
  ListItemText,
  ListItemButton,
  alpha,
  ListItemButtonProps
} from '@mui/material'
import { DropdownMenuStylesProps } from './DropdownMenu.types'
import getPaletteColor from '../../../utils/getPaletteColor'
import Icon from '../Icon'

export const DropdownWrapper = styled(Box)(
  ({ theme }) => css`
    z-index: ${theme.zIndex.appBar};
    position: relative;
    display: flex;
  `
)

export const DropdownInput = styled(InputBase)(
  ({ theme }) => css`
    cursor: pointer;
    z-index: 2;
    position: relative;
    flex: 1;
    height: 40px;
    margin: 8px;
    padding: 8px;
    border: 1px solid ${theme.palette.grey[400]};
    border-radius: 4px;
    background: ${theme.palette.background.paper};

    &:hover {
      border-color: ${theme.palette.grey[500]};
    }

    .MuiInputBase-input {
      cursor: pointer;
      position: relative;
      padding: 4px;
      padding-right: 24px;
      z-index: 1;
      color: inherit;
      font-size: inherit;

      &::placeholder {
        color: inherit;
        opacity: 1;
      }
    }

    svg {
      position: absolute;
      right: 8px;
    }
  `
)

export const DropdownIcon = styled(Icon)(() => css``)
DropdownIcon.defaultProps = {
  size: 20
}

export const DropdownListWrapper = styled(Box)(
  ({ theme }) => css`
    z-index: 1;
    opacity: 0;
    visibility: hidden;
    overflow: hidden;
    position: absolute;
    left: 0;
    right: 0;
    top: 0;
    padding: 8px;
    background: ${theme.palette.background.paper};
    box-shadow: ${theme.shadows[4]};
    border-radius: 0 0 4px 4px;
    transition: all 0.25s ease-in-out;

    &.open {
      opacity: 1;
      visibility: visible;
      top: 48px;
    }
  `
)

export const DropdownList = styled(List)(
  ({ theme }) => css`
    overflow: auto;
    height: 100%;
    max-height: 230px;
    padding: 0;
    padding-right: 2px;

    ${theme.breakpoints.up('sm')} {
      &::-webkit-scrollbar {
        width: 4px;
        height: 4px;
      }

      &::-webkit-scrollbar-thumb {
        background-color: ${theme.palette.primary.light};
        border-radius: 12px;
      }

      &::-webkit-scrollbar-thumb:hover {
        background-color: ${theme.palette.primary.main};
      }

      &::-webkit-scrollbar-track {
        background-color: transparent;
        border-radius: 12px;
      }
    }
  `
)

export const DropdownListItem = styled(ListItemButton)<
  ListItemButtonProps & DropdownMenuStylesProps
>(
  ({ theme, color = 'primary' }) => css`
    border-radius: 4px;

    &.selected {
      color: ${getPaletteColor(theme, color, 'contrastText')};
      background-color: ${getPaletteColor(theme, color)};
    }
  `
)

export const DropdownListLabel = styled(ListItemText)(() => css``)

export const DropdownBackdrop = styled(Backdrop)(
  ({ theme }) => css`
    opacity: 0.2;
    background: ${alpha(theme.palette.background.paper, 0.2)};
  `
)
